var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtChipPieChart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0V0z",
    id: "jtz7xxqhia"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#jtz7xxqhia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCB",
    d: "M39 12.23v20.213l-12.717-6.052v-6.089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.998 30.408v14.978a22.533 22.533 0 0 1-10.712 3.563 22.697 22.697 0 0 1-11.926-2.491V30.685",
    fill: "#A3AED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.176 23.688 11.822 6.713c-1.263.912-6.237 4.291-12.886 3.874-1.225-.077-5.896-.43-10.07-3.528-.063-.047-.115-.085-.148-.112",
    fill: "#CCD4EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFD9A5",
    d: "M27.217 8.311v15.446L15.77 31.27V15.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.321 11.772v34.64c-.858-.392-3.223-1.61-4.056-4.098-.14-.42-.221-.83-.261-1.217V8.44",
    fill: "#F2CD8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 15.207c-3.055-1.687-4.75-4.99-4.27-8.222C12.68 2.97 16.325 1.15 16.64 1l10.636 7.283",
    fill: "#FBEFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.23 10.153c1.76-.005 3.9.127 6.292.577 2.119.401 3.953.96 5.466 1.525L27.231 19.84",
    fill: "#EDEDED"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtChipPieChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-chip-pie-chart.e2e950be685e506ff06fc209ee719f8a.svg";